<template>
  <div class="invite-next">
    <Icon></Icon>
    <Titles></Titles>
    <el-collapse-transition>
      <Error v-if="errorShow" :msg="errorMsg" v-on:closeErrorTip="closeErrorTip"></Error>
    </el-collapse-transition>
    <Account :type="type" :content="$route.query.account" style="margin-top: 45px;"></Account>
    <!-- <Inputs :type="'name'" v-on:inputText="getName" v-show="isPhone || isEmail" v-on:enterInput="enterInput"></Inputs> -->
    <Inputs :type="'newpassword'" v-on:inputText="getNewPassword" v-on:enterInput="enterInput"></Inputs>
    <div class="button">
      <Buttons :type="'back'" :data="{type: type, username: name, password: newpassword, account: $route.query.account}" style="width: 140px;float: left;margin-top: 0;"></Buttons>
      <!-- <Buttons :type="'next'" :data="{type: 1, username: name, password: newpassword, account: $route.query.account}" style="width: 140px;float: right;margin-top: 0;" :data="$route.query.account" v-show="isPhone"></Buttons> -->
      <Buttons ref=btn :type="isPhone ? 'done' : 'done'" :data="{type: type, username: name, password: newpassword, account: $route.query.account}" v-on:openErrorTip="openErrorTip" v-on:closeErrorTip="closeErrorTip" style="width: 140px;float: right;margin-top: 0;"></Buttons>
    </div>
    <div class="foot">
      <span>{{footText}}</span>
      <a href="https://www.craitapp.com/useragreement.php" target="_blank" @click="uploadWebEvent">{{footRouter}}</a>
    </div>
  </div>
</template>

<script>
  import IconSwitch from '../components/Iconswitch'
  import Icon from '../components/Icon'
  import Titles from '../components/Title'
  import Error from '../components/Error'
  import Account from '../components/Account'
  import Inputs from '../components/Inputs'
  import GetCode from '../components/GetCode'
  import Buttons from '../components/Buttons'
  import { checkEmail, checkPhone, checkUsername } from '../common/Common.js'
  import { getCountryCode } from '../common/CountryCode.js'
  import { errorFn } from '../common/ErrorMsg.js'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import translate from '../common/Translate.js'
  export default {
    data () {
      return {
        errorShow: false,
        errorMsg: '',
        type: 0,
        name: this.$route.query.account,
        newpassword: '',
        isEmail: checkEmail(this.$route.query.account),
        isPhone: checkPhone(this.$route.query.account),
        isAccount: checkUsername(this.$route.query.account),
        footText: translate('By registering, you agree to the '),
        footRouter: translate('User agreement')
      }
    },
    components: {
      IconSwitch, Icon, Titles, Error, Account, Inputs, GetCode, Buttons
    },
    mounted () {
      if (this.isEmail) {
      } else if (this.isPhone) {
        this.type = 1
        getCountryCode()
      } else if (this.isAccount) {
        this.type = 2
      }
      // 埋点统计：邀请注册页面输入并跳转到下一页面
      uploadWebEvent('INVITE_INPUT_NEXT', {
        type: this.type
      })
    },
    methods: {
      getName (data) {
        this.name = data
      },
      getNewPassword (data) {
        this.newpassword = data
      },
      // 关闭错误提示
      closeErrorTip () {
        errorFn.closeErrorTip(this)
      },
      // 弹出错误提示
      openErrorTip (msg) {
        errorFn.openErrorTip(msg, this)
      },
      // 输入框回车点击
      enterInput () {
        this.$refs.btn.clickBtn()
      },
      uploadWebEvent () {
        // 埋点统计：邀请注册页点击查看用户协议
        uploadWebEvent('INVITENEXT_AGGREMENT', {
          type: this.type
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
	@import '../../assets/css/_mixin.scss';
  .invite-next {
    @include white-bg;
    min-height: 560px;
    margin-top: -280px;
    .button {
      width: 300px;
      height: 40px;
      margin: 0 auto;
      margin-top: 40px;
      .back {
        
      }
    }
    .foot {
      width: 100%;
      height: 14px;
      margin-top: 30px;
      margin-bottom: 60px;
      text-align: center;
      span {
        color: #939699;
      }
      a {
        color: #3f86de;
        text-decoration: none;
        cursor: pointer;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Invitenext.vue?814fdbea